import { RestClient } from '@/api/rest-client'
import { Attachment } from '@/api/model/attachment'
import { Referral } from '@/api/model/referral'
import { BaseModel } from '@/api/base-model'

export class AttachmentClient extends RestClient<Attachment> {
    collectionName = 'attachments'
    parseData = Attachment.fromData

    async create(data: any): Promise<Attachment> {
        const formData = new FormData()

        for (const [key, value] of Object.entries<any>(data)) {
            if (value === undefined || key === 'collectionName') {
                continue
            }

            formData.append(key, value instanceof BaseModel ? value.resourceIdentifier : value)
        }

        try {
            await this.client.post(`${this.basePath}/attachments`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })

            return await this.get(data.id)

        } catch (error) {
            this.handleError(error)
        }
    }

    async createWithFile(referral: Referral, id: string, file: File): Promise<void> {
        const formData = new FormData()
        formData.append('referral', referral.resourceIdentifier)
        formData.append('id', id)
        formData.append('file', file)

        try {
            await this.client.post(`${this.basePath}/attachments`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        } catch (error) {
            this.handleError(error)
        }
    }
}
